/**
 * Tracks the offset between the server's wall clock (`server_now_ms`, carried on every `/state`
 * response) and this device's clock. Venue devices are third-party Android boxes nobody can
 * reach, and their clocks drift — interpolate progress against this, never against `Date.now()`
 * directly.
 *
 * A `304` has no body and therefore no clock update: keep using the last offset measured.
 */
export class ClockOffset {
  private offsetMs = 0;
  private measuredAt: number | null = null;

  /** Call with `server_now_ms` from every `/state` response that has a body (not on 304). */
  update(serverNowMs: number): void {
    this.offsetMs = serverNowMs - Date.now();
    this.measuredAt = Date.now();
  }

  /** Best current estimate of the server's wall clock, in epoch ms. */
  now(): number {
    return Date.now() + this.offsetMs;
  }

  /** Whether a real measurement has ever landed (vs. the zero-offset default). */
  hasMeasurement(): boolean {
    return this.measuredAt !== null;
  }
}
